import { AddressTypeExtension } from "pbHelpers/AddressType";
import { quack } from "protobuf-ts/quack";

export const Modem: AddressTypeExtension = {
  addressType: quack.AddressType.ADDRESS_TYPE_MODEM,
  friendlyName: "Modem",
  humanReadableAddress: function(componentType: quack.ComponentType, address: number): string {
    return "";
  },
  singular: true
};
